import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Input } from "../../../../../../../../../components/Form";
import { useShipmentContext } from "../../../../hooks/useContext";
import { DefaultProps } from "../../../../types";
import { SectionTitle } from "../../SectionTitle";
import { ViewModeComponent } from "./view-mode";

interface AirFormAirportsProps extends DefaultProps {}

export function AirFormAirports(props: AirFormAirportsProps) {
  const { onViewMode } = props;
  const { t: translate } = useTranslation();
  const { shipment } = useShipmentContext();

  return (
    <Grid container item xs={12} direction="row" spacing={2}>
      <Grid item xs={12} md={3} lg={3}>
        <ViewModeComponent
          onViewMode={onViewMode}
          formData={{
            label: translate("airportOfOrigin"),
            value: shipment?.shipmentTracking?.originPort,
          }}
        >
          <Input
            name="originAirport"
            label={translate("airportOfOrigin")}
            value={shipment?.shipmentTracking?.originPort}
            disabled
          />
        </ViewModeComponent>
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <ViewModeComponent
          onViewMode={onViewMode}
          formData={{
            label: translate("airportOfDestination"),
            value: shipment?.shipmentTracking?.finalPort,
          }}
        >
          <Input
            name="destinationAirport"
            label={translate("airportOfDestination")}
            value={shipment?.shipmentTracking?.finalPort}
            disabled
          />
        </ViewModeComponent>
      </Grid>
    </Grid>
  );
}
